import { randomBytes } from "crypto";
import mongoose from "mongoose";

const OTP_ALPHABET = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";

/**
 * Makes a new OTP
 * The OTP will have 6 chars of uppercase letters and numbers
 * Is using a high-entropy random text generator for 6 chars overkill? Probably.
 * @returns {string}
 */
export function makeOTP(length = 6, characters = OTP_ALPHABET) {
  const characterCount = characters.length;
  const maxValidSelector = (Math.floor(0x10000 / characterCount) * characterCount) - 1;
  const entropyLength = 2 * Math.ceil(1.1 * length);
  let string = "";

  while (string.length < length) {
    const entropy = randomBytes(entropyLength);
    let entropyPosition = 0;

    while (entropyPosition < entropyLength && string.length < length) {
      const entropyValue = entropy.readUInt16LE(entropyPosition);
      entropyPosition += 2;

      if (entropyValue <= maxValidSelector) {
        string += characters[entropyValue % characterCount];
      }
    }
  }

  return string;
}

export interface OTP {
  _id: mongoose.Schema.Types.ObjectId;
  emailAddress: string;
  orderId: string;
  unsubscribe: boolean;
  otp: string;
  createdAt: Date;
}

export const OTPSchema = new mongoose.Schema<OTP>({
  emailAddress: String,
  orderId: { type: String, default: () => "" },
  unsubscribe: { type: Boolean, default: () => false },
  otp: { type: String, default: () => makeOTP() },
  createdAt: { type: Date, expires: 10 * 60, default: Date.now },
});
